import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getTenantEmailConfigurationList = createAsyncThunk(
  "TenantEmailConfiguration/get",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${API_URL.TENANT_EMAIL_CONFIGURATION.SLUG}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createTenantEmailConfiguration = createAsyncThunk(
  "TenantEmailConfiguration/create",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.post(
        `${API_URL.TENANT_EMAIL_CONFIGURATION.SLUG}`,
        payload
      );
      dispatch(getTenantEmailConfigurationList());
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editTenantEmailConfiguration = createAsyncThunk(
  "TenantEmailConfiguration/put",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.put(
        `${API_URL.TENANT_EMAIL_CONFIGURATION.SLUG}/${payload.id}`,
        payload
      );
      dispatch(getTenantEmailConfigurationList());
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteTenantEmailConfiguration = createAsyncThunk(
  "TenantEmailConfiguration/delete",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.delete(
        `${API_URL.TENANT_EMAIL_CONFIGURATION.SLUG}/${payload.id}`
      );
      dispatch(getTenantEmailConfigurationList());
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const makeConfigurationDefault = createAsyncThunk(
  "TenantEmailConfiguration/create",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      console.log("enter");
      const { data } = await axios.put(
        `${API_URL.TENANT_EMAIL_CONFIGURATION.SLUG}/${payload.id}/set-default`
      );
      dispatch(getTenantEmailConfigurationList());
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

const tenantEmailConfigurationSlice = createSlice({
  name: "tenantEmailConfiguration",
  initialState: {
    current_values: null,
    tenant_email_configuration_list: [],
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getTenantEmailConfigurationList.fulfilled,
      (state, action) => {
        state.tenant_email_configuration_list = action.payload;
      }
    );
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } =
  tenantEmailConfigurationSlice.actions;
export default tenantEmailConfigurationSlice.reducer;
